"use client"
import { useEffect, useState } from "react"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import { Modal, NextImage, Icons } from "@src/components"
import { useTranslation } from "react-i18next"

export default function SizeModal(props: {
  imgUrl?: string
  images?: string[]
  open: boolean
  onClose: () => void
}) {
  const { imgUrl, images, open, onClose } = props
  const { t } = useTranslation()
  const charts = (images?.filter(Boolean)?.length
    ? images.filter(Boolean)
    : imgUrl
      ? [imgUrl]
      : []) as string[]
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (open) setIndex(0)
  }, [open])

  const current = charts[index] || ""
  const hasMultiple = charts.length > 1

  const goPrev = () => {
    setIndex(prev => (prev - 1 + charts.length) % charts.length)
  }

  const goNext = () => {
    setIndex(prev => (prev + 1) % charts.length)
  }

  return (
    <Modal
      title={t("size_selection_guide")}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          margin: "0px 16px",
          overflow: "auto",
          width: "fit-content",
          minWidth: {
            xs: "calc(100% - 32px)",
            md: "auto"
          }
        }
      }}
    >
      <Box position="relative" display="flex" alignItems="center" justifyContent="center">
        {hasMultiple && (
          <Stack
            sx={{
              position: "absolute",
              left: { xs: 0, md: 8 },
              zIndex: 2,
              top: "50%",
              transform: "translateY(-50%)"
            }}
          >
            <Icons
              name="caret-left"
              type="button"
              onClick={goPrev}
              sx={{
                background: "rgba(255, 255, 255, 0.9)",
                "&:hover": { background: "#fff" }
              }}
            />
          </Stack>
        )}
        {current ? (
          <NextImage
            alt={`product size ${index + 1}`}
            src={current}
            sx={{
              width: "100%",
              height: "auto",
              "& .next-image-full": {
                position: "relative !important",
                maxHeight: "80vh"
              }
            }}
          />
        ) : null}
        {hasMultiple && (
          <Stack
            sx={{
              position: "absolute",
              right: { xs: 0, md: 8 },
              zIndex: 2,
              top: "50%",
              transform: "translateY(-50%)"
            }}
          >
            <Icons
              name="caret-right"
              type="button"
              onClick={goNext}
              sx={{
                background: "rgba(255, 255, 255, 0.9)",
                "&:hover": { background: "#fff" }
              }}
            />
          </Stack>
        )}
      </Box>
      {hasMultiple && (
        <Box textAlign="center" mt={1} fontSize={12} color="rgba(0,0,0,0.55)">
          {index + 1} / {charts.length}
        </Box>
      )}
    </Modal>
  )
}
